import { useState, useMemo } from "react";
import { useLoader } from "@react-three/fiber";
import { TextureLoader, Quaternion, Vector3 } from "three";

const randomSpherical = () => ({
  phi: Math.acos(2 * Math.random() - 1),
  theta: Math.random() * 2 * Math.PI,
});

const Cat = ({ textureUrl, shrinks = false, onExtraClick, hidden = false }) => {
  const texture = useLoader(TextureLoader, textureUrl);
  const [{ phi, theta }, setCoords] = useState(randomSpherical);
  const [size, setSize] = useState(0.24);

  const x = Math.sin(phi) * Math.cos(theta);
  const y = Math.cos(phi);
  const z = Math.sin(phi) * Math.sin(theta);

  const quaternion = useMemo(() => {
    return new Quaternion().setFromUnitVectors(
      new Vector3(0, 0, 1),
      new Vector3(x, y, z)
    );
  }, [x, y, z]);

  const handleClick = (e) => {
    e.stopPropagation();
    setCoords(randomSpherical());
    if (shrinks) setSize((s) => s * 0.9);
    if (onExtraClick) onExtraClick();
  };

  if (hidden) return null;

  return (
    <group quaternion={quaternion}>
      <mesh position={[0, 0, 1.015]} onClick={handleClick}>
        <planeGeometry args={[size, size]} />
        <meshBasicMaterial
          map={texture}
          transparent
          alphaTest={0.5}
          depthWrite={false}
        />
      </mesh>
    </group>
  );
};

export default Cat;
